import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader, CheckCircle, XCircle } from 'lucide-react';
import { verifyFunding } from '../services/walletService';
import { useAuth } from '../context/AuthContext';

const WalletFundingConfirmPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [status, setStatus] = useState('verifying');

  useEffect(() => {
    let isSubscribed = true;

    const verify = async () => {
      const reference = new URLSearchParams(location.search).get('reference');
      if (!reference) {
        if (isSubscribed) setStatus('failed');
        return;
      }
      try {
        const result = await verifyFunding(reference);
        if (isSubscribed) setStatus(result.status ? 'success' : 'failed');
      } catch (err) {
        if (isSubscribed) setStatus('failed');
      }
    };

    const timeout = setTimeout(verify, 100);
    return () => { isSubscribed = false; clearTimeout(timeout); };
  }, [location]);

  const dashboardPath = user?.role === 'venue' ? '/venue' : '/therapist';

  if (status === 'verifying') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader className="w-12 h-12 animate-spin text-primary mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-800">Verifying payment...</h2>
        </div>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-red-600 mb-4">Funding verification failed</h2>
          <button onClick={() => navigate(dashboardPath)} className="bg-black text-white py-2.5 px-6 rounded-lg">
            Back to dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Wallet funded successfully!</h2>
        <button onClick={() => navigate(dashboardPath)} className="bg-black text-white py-2.5 px-6 rounded-lg">
          Back to dashboard
        </button>
      </div>
    </div>
  );
};

export default WalletFundingConfirmPage;
